import { Helmet } from 'react-helmet';
import { useAppContext } from '@front-activerse/common-components';

const SEO = () => {
  const {
    consts: { siteMetadata },
  } = useAppContext();

  // favicons generated by https://realfavicongenerator.net/=
  return (
    <Helmet>
      <title>{siteMetadata.title}</title>

      {/* <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" /> */}

      <link rel="icon" type="image/x-icon" href="/favicon.ico" />
      <link rel="manifest" href="/site.webmanifest" />

      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="msapplication-TileColor" content="#000000" />
      <meta name="theme-color" content="#ffffff" />

      <meta name="description" content={siteMetadata.description} />
      <meta name="author" content={siteMetadata.author} />
      <meta name="keywords" content={siteMetadata.keywords.join(', ')} />

      <meta name="og:title" content={siteMetadata.title} />
      <meta name="og:description" content={siteMetadata.description} />
      <meta name="og:type" content="website" />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content={siteMetadata.author} />
      <meta name="twitter:title" content={siteMetadata.title} />
      <meta name="twitter:description" content={siteMetadata.description} />

      <meta name="apple=mobile-web-app-title" content={siteMetadata.shortName} />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
    </Helmet>
  );
};

export default SEO;
